export default function ({ store }) {
  document.addEventListener("scroll", function (event) {
    let isScrolledDown = window.scrollY > 0
    
    if (isScrolledDown != store.state.isScrolledDown) {
      store.commit("header/updateField", { path: "isScrolledDown", value: isScrolledDown }, { root: true })
    }
  })
}